import React, { useContext, useState } from "react";
import "./styles.css";
import { Context } from "../../../index";
import { observer } from "mobx-react-lite";
import ButtonComponent from "../../buttons/ButtonComponent";
import UniversalForm from "../../forms/UniversalForm";
import Modal from "../../forms/wrap/Modal";
import { useModal } from "../../hooks/useModal";
import { toast } from "react-toastify";

function InfoBoard() {
  const { store, inplantsStore } = useContext(Context);
  const stationsQuantity = inplantsStore.stations.filter(
    (el) => el.plant_id === store.plant?.id && el["Meters.meter_address"] !== 0,
  ).length;
  const modal = useModal(false);
  const [showDateRange, setShowDateRange] = useState(false); // ← новое состояние

  // Опции периода
  const exportOptions = [
    { id: "current", name: "Текущий месяц" },
    { id: "previous", name: "Прошлый месяц" },
    { id: "range", name: "Интервал" },
  ];

  // Обработчик выбора периода
  const handlePeriodChange = (field: string, value: string) => {
    if (field === "period") {
      setShowDateRange(value === "range");
    }
  };

  // 🚀 Отправка формы
  const handleExportSubmit = async (data: Record<string, string>) => {
    const { period, dateRange, format } = data; // ← format уже есть!
    const selected = period;

    if (!selected) {
      toast.error("Пожалуйста, выберите период");
      return;
    }

    let startDate: string, endDate: string;
    const now = new Date();

    switch (selected) {
      case "current": {
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        startDate = `${year}-${month}-01`;
        endDate = `${year}-${month}-${day}`;
        break;
      }

      case "previous": {
        const prevMonthDate = new Date(
          now.getFullYear(),
          now.getMonth() - 1,
          1,
        );
        const year = prevMonthDate.getFullYear();
        const month = prevMonthDate.getMonth();

        startDate = `${year}-${String(month + 1).padStart(2, "0")}-01`;

        const lastDay = new Date(year, month + 1, 0);
        const eYear = lastDay.getFullYear();
        const eMonth = String(lastDay.getMonth() + 1).padStart(2, "0");
        const eDay = String(lastDay.getDate()).padStart(2, "0");
        endDate = `${eYear}-${eMonth}-${eDay}`;
        break;
      }

      case "range": {
        const rangeValue = dateRange;
        if (!rangeValue || !rangeValue.includes("_")) {
          toast.error("Пожалуйста, выберите корректный диапазон дат");
          return;
        }

        [startDate, endDate] = rangeValue.split("_");

        if (!startDate || !endDate) {
          toast.error("Заполните обе даты");
          return;
        }

        if (new Date(startDate) > new Date(endDate)) {
          toast.error("Начальная дата не может быть позже конечной");
          return;
        }
        break;
      }

      default:
        toast.error("Неизвестный период");
        return;
    }

    try {
      // ✅ Передаём format третьим аргументом!
      await store.exportReadings(startDate, endDate, format as "excel" | "pdf");

      toast.success(`Экспорт показаний с ${startDate} по ${endDate} запущен!`);
      modal.close();
    } catch (error) {
      toast.error("Ошибка при запуске экспорта");
    }
  };

  const closeModal = () => {
    modal.close();
    store.setPoll(true);
  };

  const openModal = () => {
    modal.open();
    store.setPoll(false);
  };

  return (
    <>
      <div className="info-bord_container">
        <div className="info-bord">
          <div className="info-bord_logo">
            {store.company?.logoUrl && (
              <img
                src={`${process.env.REACT_APP_API_URL}${store.company.logoUrl}`}
                alt="Company Logo"
                className="info-bord_logo"
              />
            )}
          </div>

          <div className="info-bord_block">
            <div className="info-bord_name">{store.company?.name}</div>
          </div>

          <div className="info_bord_btn">
            {/* Здесь можно добавить другие кнопки, если нужно */}
          </div>
        </div>

        {store.plant?.id && (
          <div className="plantBunner_container">
            <div className="plantBunner_title">{store.plant?.name}</div>

            <div className="plantBunner_item">
              <div className="plantBunner_field">
                <span className="plantBunner_label">Город:</span>
                <span className="plantBunner_value">{store.plant?.city}</span>
              </div>
              <div className="plantBunner_field">
                <span className="plantBunner_label">Адрес:</span>
                <span className="plantBunner_value">{store.plant?.adress}</span>
              </div>
              <div className="plantBunner_field">
                <span className="plantBunner_label">Станции:</span>
                <span className="plantBunner_value">
                  {stationsQuantity} шт.
                </span>
              </div>
            </div>

            <ButtonComponent title="Экспорт показаний" onClick={openModal} />
          </div>
        )}
      </div>

      {/* 🎯 Модалка с формой экспорта */}
      <Modal isOpen={modal.isOpen} onClose={modal.close}>
        <UniversalForm
          mode="export"
          fields={{
            period: {
              label: "Период",
              type: "select",
              options: exportOptions,
              required: true,
            },
            ...(showDateRange && {
              dateRange: { label: "Диапазон дат", type: "dateRange", required: true },
            }),
          }}
          title={`Экспортировать показания ${store.plant?.name}`}
          handleCloseModal={closeModal}
          createEntity={handleExportSubmit}
          onFieldChange={handlePeriodChange}
          submitButtonText="Экспортировать"
        />
      </Modal>
    </>
  );
}

export default observer(InfoBoard);
